// extracted by extract-css-chunks-webpack-plugin
module.exports = {"heading":"css-2VTF9Kpg4p","heading_inner":"css-7gokYh9j6e","heading_inner__emOnly":"css-2DpPzLnBQy","heading__inlineCategoryContent":"css-19f7K9W0hz"};